// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3LUvGmI2sjXoCUr_s3ODvC","right":"_1G2WTlUJP7z89QACh1Hlb1"};